/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdateProfileSkillRequest } from './';
import {
    UpdateProfileSkillRequestFromJSON,
    UpdateProfileSkillRequestFromJSONTyped,
    UpdateProfileSkillRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateProfileTopSkillsRequest
 */
export interface UpdateProfileTopSkillsRequest {
    /**
     * 
     * @type {Array<UpdateProfileSkillRequest>}
     * @memberof UpdateProfileTopSkillsRequest
     */
    topSkills: Array<UpdateProfileSkillRequest>;
}

/**
 * Check if a given object implements the UpdateProfileTopSkillsRequest interface.
 */
export function instanceOfUpdateProfileTopSkillsRequest(value: object): value is UpdateProfileTopSkillsRequest {
    if (!('topSkills' in value) || value['topSkills'] === undefined) return false;
    return true;
}

export function UpdateProfileTopSkillsRequestFromJSON(json: any): UpdateProfileTopSkillsRequest {
    return UpdateProfileTopSkillsRequestFromJSONTyped(json, false);
}

export function UpdateProfileTopSkillsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProfileTopSkillsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'topSkills': ((json['topSkills'] as Array<any>).map(UpdateProfileSkillRequestFromJSON)),
    };
}

export function UpdateProfileTopSkillsRequestToJSON(value?: UpdateProfileTopSkillsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'topSkills': ((value['topSkills'] as Array<any>).map((v) => UpdateProfileSkillRequestToJSON(v))),
    };
}

